import { render, staticRenderFns } from "./teachingArchives.vue?vue&type=template&id=37101f8c"
import script from "./teachingArchives.vue?vue&type=script&lang=js"
export * from "./teachingArchives.vue?vue&type=script&lang=js"
import style0 from "./teachingArchives.vue?vue&type=style&index=0&id=37101f8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports